import axiosInstance from "../axiosInstance";

const getResource = async (path) =>
  axiosInstance
    .get(path)
    .then((response) => response?.data)
    .catch((error) => {
      throw error?.response?.data ?? error;
    });

export const getMhdProfile = (applicationId) =>
  getResource(`/MhdProfile/GetMhd/${applicationId}`);

export const getMhdApartment = (applicationId, apartmentId) =>
  getResource(`/MhdProfile/GetApartment/${applicationId}/${apartmentId}`);

export const getMhdChild = (applicationId, childId) =>
  getResource(`/MhdProfile/GetChild/${applicationId}/${childId}`);

export const assignChildProtectionOfficer = (payload) =>
  axiosInstance
    .post("/MhdProfile/AssignChildProtectionOfficer", payload)
    .then((response) => response?.data)
    .catch((error) => {
      throw error?.response?.data ?? error;
    });

export const deleteChildProtectionOfficer = (applicationId, assignmentId) =>
  axiosInstance
    .delete(`/MhdProfile/DeleteChildProtectionOfficer/${applicationId}/${assignmentId}`)
    .then((response) => response?.data)
    .catch((error) => {
      throw error?.response?.data ?? error;
    });

export const downloadMhdChildAttachment = async ({
  applicationId,
  childId,
  attachmentId,
  source,
  fileName,
}) => {
  const response = await axiosInstance.get(
    `/MhdProfile/DownloadChildAttachment/${applicationId}/${childId}/${attachmentId}`,
    { params: { source }, responseType: "blob" },
  );
  const url = window.URL.createObjectURL(response.data);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName || "document";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
};

export const getMhdChildAttachmentBlob = async ({
  applicationId,
  childId,
  attachmentId,
  source,
}) => {
  const response = await axiosInstance.get(
    `/MhdProfile/DownloadChildAttachment/${applicationId}/${childId}/${attachmentId}`,
    { params: { source }, responseType: "blob" },
  );
  return response.data;
};
